import React, { FunctionComponent } from "react";
import styles from "./Statements.module.scss";
import StatementsBlockProps from "./StatementsProps.interface";

import Statement from "./components/Statement/Statement";
import combineClasses from "helpers/combine-classes";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useAnchor from "blocks/hooks/useAnchor";

const Statements: FunctionComponent<StatementsBlockProps> = (props): JSX.Element => {
    const listSizeClass = props.settings.listSize ? styles[props.settings.listSize] : undefined;

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    return (
        <section className={combineClasses(styles.wrapper, listSizeClass)} style={{ ...splitStyles }} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses)}>
                {props.content.statements && props.content.statements.length > 0 ? (
                    <div className={styles.list}>
                        {props.content.statements.map((statement, index) => {
                            return (
                                <Statement key={index} {...statement} />
                            );
                        })}
                    </div>
                ) : null}
            </div>
        </section>
    );
};

export default Statements;